// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box[data-v-18e3b2ad]{border-radius:10px}.single-item[data-v-18e3b2ad]{width:270px;max-width:270px}.single-item.desktop[data-v-18e3b2ad]{width:370px!important;max-width:unset}.v-card[data-v-18e3b2ad]{border-radius:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
